<template>
    <EditModelLayout
        :indexRoute="$route('admin::my-vacations.index')"
        :updateRoute="$route('admin::my-vacations.update', { vacation: vacation.id })"
        :modelNameSingular="__('admin::vacations.vacation_request')"
        :modelNamePlural="__('admin::vacations.vacation_requests')"
        :form="form"
        :name="form.name"
    >

        <VacationForm
            v-model="form"
            :userOptions="userOptions"
            :vacationMessageDefault="vacationMessageDefault"
        />

    </EditModelLayout>
</template>

<script>
export default {
    props: {
        vacation: Object,
        userOptions: Object,
        vacationMessageDefault: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                starts_at: this.vacation.starts_at,
                ends_at: this.vacation.ends_at,
                returns_at: this.vacation.returns_at,
                days_to_show_notice_before_start: this.vacation.days_to_show_notice_before_start,
                deputy_user_id: this.vacation.deputy_user_id,
                comment: this.vacation.comment,
                use_default_messages: this.vacation.use_default_messages,
                appendix_before_vacation_message: this.vacation.appendix_before_vacation_message,
                appendix_during_vacation_message: this.vacation.appendix_during_vacation_message,
                autoreply_subject: this.vacation.autoreply_subject,
                autoreply_message: this.vacation.autoreply_message,
            })
        }
    },
}
</script>
